export default __webpack_public_path__ + "static/media/tele.67c51a2c.svg";